import React from 'react';
import { Link } from 'react-router-dom';

const PublicHelp: React.FC = () => (
  <>
    <section className="text-center px-4 sm:px-6 py-16 sm:py-24 max-w-4xl mx-auto">
      <h1
        className="text-5xl sm:text-6xl md:text-7xl font-bold text-[var(--text)] leading-[1.05] tracking-tight mb-6"
        style={{ fontFamily: "'Quicksand', sans-serif" }}
      >
        How can we help?
      </h1>
      <p className="text-lg sm:text-xl md:text-2xl text-[var(--text-muted)] leading-relaxed max-w-2xl mx-auto">
        Reach the team for onboarding, deliverability questions, custom plans,
        or anything blocking you from sending your next campaign.
      </p>
    </section>

    <section className="px-4 sm:px-6 pb-12 sm:pb-16">
      <div className="max-w-3xl mx-auto grid gap-4 sm:grid-cols-2">
        <a
          href="mailto:support@travelminds.com"
          className="block bg-white border border-[var(--border)] rounded-lg p-6 hover:border-[var(--accent)] hover:shadow-sm transition-all"
        >
          <h3 className="font-semibold text-[var(--text)] mb-1">Email support</h3>
          <p className="text-sm text-[var(--text-muted)] mb-3">For onboarding, billing, deliverability, anything technical.</p>
          <span className="text-sm text-[var(--accent)]">support@travelminds.com →</span>
        </a>
        <Link
          to="/faq"
          className="block bg-white border border-[var(--border)] rounded-lg p-6 hover:border-[var(--accent)] hover:shadow-sm transition-all"
        >
          <h3 className="font-semibold text-[var(--text)] mb-1">Read the FAQ</h3>
          <p className="text-sm text-[var(--text-muted)] mb-3">The 10 questions agencies ask most often. Quick read.</p>
          <span className="text-sm text-[var(--accent)]">View FAQ →</span>
        </Link>
      </div>
    </section>

    <section className="px-4 sm:px-6 py-12 sm:py-16 bg-[var(--bg)]">
      <div className="max-w-3xl mx-auto">
        <h2
          className="text-2xl sm:text-3xl font-bold text-[var(--text)] text-center mb-8"
          style={{ fontFamily: "'Quicksand', sans-serif" }}
        >
          Working with TravelMinds
        </h2>
        <div className="space-y-4 text-[var(--text)]">
          <div className="bg-white border border-[var(--border)] rounded-lg p-5">
            <h3 className="font-semibold mb-1">Response times</h3>
            <p className="text-sm text-[var(--text-muted)]">
              Standard support replies within one business day. Priority and Enterprise plans get same-business-day response and direct contact channels.
            </p>
          </div>
          <div className="bg-white border border-[var(--border)] rounded-lg p-5">
            <h3 className="font-semibold mb-1">Onboarding</h3>
            <p className="text-sm text-[var(--text-muted)]">
              We help with DNS setup (DKIM, SPF, DMARC), contact import, brand assets, and your first campaign template. Typically a single 30-minute call covers it.
            </p>
          </div>
          <div className="bg-white border border-[var(--border)] rounded-lg p-5">
            <h3 className="font-semibold mb-1">Security</h3>
            <p className="text-sm text-[var(--text-muted)]">
              Issues can be reported confidentially to security@travelminds.com — we acknowledge within one business day.
            </p>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default PublicHelp;
